module.exports = __webpack_public_path__ + "img/zx.45f226ad.png";